enum EvaluateStrategy {
  ExitOnFirstInequality = 0,
  EvaluateAll = 1
}

/**
 * Traverse array backward, remove last item if it's equal (===) to the penultimate item. Return on first unequal
 * Todo: If needed, could pass a custom equality check method for more robust usage
 * @param parts
 * @returns Trimmed array
 */
export const removeSuccessive = <T>(
  parts: T[],
  evaluateStrategy: EvaluateStrategy = EvaluateStrategy.ExitOnFirstInequality
): T[] => {
  if (!Array.isArray(parts) || parts.length < 2) {
    return parts || [];
  }

  for (let i = parts.length - 1; i >= 1; i--) {
    if (parts[i] === parts[i - 1]) {
      parts.splice(i, 1);
    } else if (evaluateStrategy === EvaluateStrategy.ExitOnFirstInequality) {
      break;
    }
  }
  return parts;
};
